import React from 'react';
import {
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaWhatsapp,
  FaEnvelope,
} from 'react-icons/fa';

const socialLinks = [
  {
    label: 'Instagram',
    value: 'BiteJoy_family',
    icon: <FaInstagram aria-hidden="true" />,
    href: 'https://www.instagram.com/BiteJoy_family',
  },
  {
    label: 'Facebook',
    value: 'BiteJoy_family',
    icon: <FaFacebookF aria-hidden="true" />,
    href: 'https://www.facebook.com/BiteJoy_family',
  },
  {
    label: 'YouTube',
    value: 'BiteJoy_family',
    icon: <FaYoutube aria-hidden="true" />,
    href: 'https://www.youtube.com/@BiteJoy_family',
  },
  {
    label: "What's App",
    value: '+91 9022880420',
    icon: <FaWhatsapp aria-hidden="true" />,
    href: 'https://wa.me/919022880420',
  },
  {
    label: 'Mail',
    value: 'bitejoychocolates@gmail.com',
    icon: <FaEnvelope aria-hidden="true" />,
    href: 'mailto:bitejoychocolates@gmail.com',
  },
];

const FooterSection = () => {
  return (
    <footer className="bitejoy-footer" id="footer">
      <div className="container py-5">
        <div className="bitejoy-footer-top text-center mb-4">
          <h3 className="bitejoy-footer-title mb-2">BiteJoy Chocolates</h3>
          <p className="bitejoy-footer-subtitle mb-0">
            Crafted with care, shared with love. Connect with us anytime.
          </p>
        </div>

        <div className="bitejoy-social-grid" role="list">
          {socialLinks.map((item) => (
            <a
              key={item.label}
              className="bitejoy-social-card"
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${item.label}: ${item.value}`}
              role="listitem"
            >
              <span className="bitejoy-social-icon">{item.icon}</span>
              <span className="bitejoy-social-text">
                <strong>{item.label}</strong>
                <small>{item.value}</small>
              </span>
            </a>
          ))}
        </div>

        <div className="bitejoy-footer-bottom text-center mt-4 pt-3">
          <p className="mb-0">
            © {new Date().getFullYear()} BiteJoy. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
